<template>
  <div class="column is-four-fifth customer">
    <h4 class="title is-4">Bokningar</h4>
    <table class="table">
      <thead>
        <tr>
          <th>Kurs</th>
          <th>Bokningsdatum</th>
          <th>Betalningsmetod</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="booking in allBookings"
          :key="booking.id"
          :class="{ inactive: booking.canceled }"
        >
          <td>
            <router-link :to="'courses?id=' + booking.course._id"
              >{{ booking.course.type }}
              {{ booking.course.startDate | formatDate }} -
              {{ booking.course.endDate | formatDate }} |
              {{ booking.course.time }}
            </router-link>
          </td>
          <td>{{ booking.created | formatDateHour }}</td>
          <td>{{ booking.paymentMethod }}</td>
          <td>
            <a
              class="button is-danger cancel-booking"
              v-if="!booking.canceled"
              @click="cancelBooking(booking._id)"
              >Ta bort bokning</a
            >
            <p v-if="booking.canceled">Bokning cancelerad</p>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="buttons">
      <create-course-booking
        :customer="customer"
        :reloadCustomer="fetchCourses"
      ></create-course-booking>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";
import CreateCourseBooking from "@/components/AdminCustomers/CreateCourseBooking.vue";

export default {
  name: "CustomerBookings",
  components: {
    CreateCourseBooking,
  },
  props: {
    customer: Object,
  },
  data: function () {
    return {
      bookings: [],
      createBookingActive: false,
      extendedFields: false,
    };
  },
  methods: {
    fetchCourses() {
      axios
        .get("/api/customers/" + this.customer._id + "/bookings")
        .then((response) => {
          this.bookings = response.data;
        });
    },
    updateCustomer() {
      console.log(this.customer.member);
      axios.put("/api/customers/" + this.customer._id + "/", this.customer);
    },
    cancelBooking: function (id) {
      if (confirm("Är du säker att du vill radera bokningen?")) {
        axios.patch("/api/bookings/" + id + "/cancel").then(() => {
          this.fetchCourses();
        });
      }
    },
    getExtendedFields: function () {
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
  },
  created() {
    this.fetchCourses();
    this.getExtendedFields();
  },
  computed: {
    allBookings: function() {
      return Object.assign({}, this.bookings)
    }
  },
  watch: {
    customer: function () {
      this.fetchCourses();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info {
  text-align: left;
}

#copyMail {
  position: absolute;
  top: -200px;
}

.customer {
  text-align: left;
}

.inactive {
  color: hsl(0, 0%, 60%);
}

.inactive a {
  color: hsl(0, 0%, 60%);
}

.inactive p {
  color: hsl(0, 0%, 0%);
}

.fas {
  margin-right: 15px;
  width: 20px;
  text-align: center;
}
</style>